import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import { API_BASE_URL } from '@/constants/ApiConstant';
import { useSelector } from 'react-redux';

const statusTxt = s => ({ 0: 'Pending', 1: 'Rejected', 2: 'Approved' }[s] ?? s);

export default function DataTable({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleDrawerOpen,
  deleteRecord,
  refresh,
  authHeaders, // ← injected from page (includes X-Company-Id / X-Branch-Id)
}) {
  const { userData: user } = useSelector(s => s.Auth);

  const canApprove = !!(
    user?.isSuperAdmin || user?.permissions?.includes('update_leave')
  );

  // Ensure we always have JSON header too for PUT
  const hdrJson = {
    'Content-Type': 'application/json',
    ...(authHeaders || {}),
  };

  const setStatus = async (id, val) => {
    const r = await fetch(
      `${API_BASE_URL}/leave-request/${id}`,
      {
        method: 'PUT',
        headers: hdrJson,
        body: JSON.stringify({ status: val }),
      }
    ).then(r => r.json());
    if (r.success) refresh();
  };

  return (
    <TableWrapServerSide
      tableColumnList={tableColumn}
      totalDataCount={totalRecord}
      initialPage={dataFilter.page}
      per_page={dataFilter.limit}
      onChangePage={onChangePage}
    >
      {dataSource.length ? (
        dataSource.map(req => (
          <tr key={req._id} className="db-table-body-tr">
            <td className="db-table-body-td">
              {req.employee?.name || req.employee}
            </td>
            <td className="db-table-body-td">{req.leaveType}</td>
            <td className="db-table-body-td">
              {String(req.startDate).slice(0, 10)}
            </td>
            <td className="db-table-body-td">
              {String(req.endDate).slice(0, 10)}
            </td>
            <td className="db-table-body-td">{req.reason}</td>

            <td className="db-table-body-td">
              <span
                className={`px-2 py-1 rounded text-xs font-medium ${
                  req.status === 0
                    ? 'bg-yellow-400 text-black'
                    : req.status === 1
                    ? 'bg-red-500 text-white'
                    : req.status === 2
                    ? 'bg-green-500 text-white'
                    : ''
                }`}
              >
                {statusTxt(req.status)}
              </span>
            </td>

            <td className="db-table-body-td hidden-print">
              <div className="flex gap-1">
                {/* Edit */}
                <button
                  className="db-table-action edit"
                  onClick={() => handleDrawerOpen(req._id)}
                >
                  <i className="lab lab-edit-line" />
                  <span className="db-tooltip">Edit</span>
                </button>

                {/* Delete */}
                <button
                  className="db-table-action delete"
                  onClick={() => deleteRecord(req._id)}
                >
                  <i className="lab lab-delete" />
                  <span className="db-tooltip">Delete</span>
                </button>

                {/* Approve / Reject */}
                {canApprove && req.status === 0 && (
                  <>
                    <button
                      className="db-table-action approve"
                      onClick={() => setStatus(req._id, 2)}
                    >
                      <i className="lab lab-check-line" />
                      <span className="db-tooltip">Approve</span>
                    </button>
                    <button
                      className="db-table-action reject"
                      onClick={() => setStatus(req._id, 1)}
                    >
                      <i className="lab lab-close-line" />
                      <span className="db-tooltip">Reject</span>
                    </button>
                  </>
                )}
              </div>
            </td>
          </tr>
        ))
      ) : (
        <IsLoadingNotFound
          isLoading={isLoading}
          colSpan={tableColumn.length}
        />
      )}
    </TableWrapServerSide>
  );
}
